export default function (Alpine) {
    Alpine.store('callForm', {
        open: false,

        show() {
            this.open = true;
        },

        close() {
            this.open = false;
        },
    });
}
